import { FormEvent, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import { authService } from '../services/authService'

export default function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)
  const [saving, setSaving] = useState(false)

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setError('')
    const data = new FormData(event.currentTarget)
    const password = String(data.get('new_password'))
    if (password !== String(data.get('confirm_password'))) {
      setError('The new passwords do not match.')
      return
    }
    setSaving(true)
    try {
      await authService.resetPassword(token, password)
      setDone(true)
    } catch (failure: any) {
      const response = failure?.response?.data
      setError(response ? Object.values(response).flat().join(' ') : 'The password could not be reset. Try again.')
    } finally {
      setSaving(false)
    }
  }

  return <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
    <div className="card w-full max-w-md"><div className="card-content space-y-4">
      <h1 className="text-xl font-semibold text-gray-900">Set a new password</h1>
      {!token ? <>
        <p className="text-sm text-gray-700">This link is missing its reset code. Ask for a new link.</p>
        <Link to="/forgot-password" className="btn btn-primary block w-full text-center">Ask for a new link</Link>
      </> : done ? <>
        <p className="text-sm text-gray-700">Your password has been changed. Sign in with the new one.</p>
        <Link to="/login" className="btn btn-primary block w-full text-center">Sign in</Link>
      </> : <form onSubmit={submit} className="space-y-3">
        {error && <div className="rounded bg-red-50 p-3 text-sm text-red-700">{error}</div>}
        <input required minLength={8} type="password" name="new_password" className="input" placeholder="New password" autoComplete="new-password" />
        <input required minLength={8} type="password" name="confirm_password" className="input" placeholder="Confirm new password" autoComplete="new-password" />
        <button disabled={saving} className="btn btn-primary w-full">{saving ? 'Saving…' : 'Set new password'}</button>
        <Link to="/forgot-password" className="block text-center text-sm text-primary-600 hover:underline">Link expired? Ask for a new one</Link>
      </form>}
    </div></div>
  </div>
}
